import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { PanelModule } from 'primeng/panel';
import { ToastModule } from 'primeng/toast';
import { TableModule } from 'primeng/table';
import { MessageModule } from 'primeng/message';
import { CardModule } from 'primeng/card';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { DialogModule } from 'primeng/dialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MessagesModule } from 'primeng/messages';
import { MenubarModule } from 'primeng/menubar';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ProgressBarModule } from 'primeng/progressbar';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { PaginatorModule } from 'primeng/paginator';
import { TabViewModule } from 'primeng/tabview';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InplaceModule } from 'primeng/inplace';

@NgModule({
  exports: [
    ButtonModule,
    PanelModule,
    ToastModule,
    CardModule,
    TableModule,
    MessageModule,
    ProgressSpinnerModule,
    OverlayPanelModule,
    DynamicDialogModule,
    DialogModule,
    InputTextareaModule,
    MessagesModule,
    MenubarModule,
    ToggleButtonModule,
    ProgressBarModule,
    DividerModule,
    DropdownModule,
    PaginatorModule,
    TabViewModule,
    AutoCompleteModule,
    InplaceModule,
  ],
})
export class NgPrimeModule {}
